import React from 'react';
import {USER_CURRENT_KEY} from "../api/public-voissa/users";
import _ from "lodash";
import {useQueryClient} from "@tanstack/react-query";

//todo: voir avec Max
const Authenticated = ({
       passThrough = false,
       children = React.ReactNode
   }) =>{
    const queryClient = useQueryClient();

    const dataCurrentUser = queryClient.getQueryData([USER_CURRENT_KEY]);
    const isCurrentUser = !!_.get(dataCurrentUser, '_id');

    function renderChildren() {
        return typeof children === 'function'
            ? children(isCurrentUser)
            : children;
    }

    return !!passThrough || isCurrentUser ? renderChildren() : null;
};

export default Authenticated;
/*
class Authenticated2 extends PureComponent {
    constructor(...args) {
        super(...args);
        this._isAllowed = false;
    }

    get allowed() {
        return this._isAllowed;
    }

    isAllowed() {
        let allowed = !!this.props.authenticated;
        return (!!this.props.not ? !allowed : allowed);
    }

    render() {
        this._isAllowed = this.isAllowed();
        return !!this.props.passThrough || this._isAllowed ? this.renderChildren() : null;
    }

    renderChildren() {
        const {children} = this.props;
        return typeof children === 'function'
            ? children(this._isAllowed)
            : children;
    }
}
/*
const mapStateToProps = (state) => {
    return {
        authenticated: state.currentUser.initialized
    }
};

export default connect(mapStateToProps, null, null, {forwardRef: true})(Authenticated);*/

